import React from 'react';
import { Accordion, PopupDialogbox, RadioContainer, Table } from '../../../../../../CommonComponents';
import './RequestReasonDetail.scss'
import Rejected from '../../../../../../assets/images/Rejected.svg'
import Approved from '../../../../../../assets/images/PenndingApproval/Approved.svg'
import Moreinfo from '../../../../../../assets/images/PenndingApproval/More Info.svg'
import { CONSTANTS } from 'client/utils/constants';
import RequestReasonDetailApprovalOrder from '../RequestReasonDetailApprovalOrder';

const RequestReasonDetail = (props: any) => {

    let lengthPlanned = props.planned?.length ?? 0;
    let lengthUnPlanned = props.unplanned?.length ?? 0;
    let lengthGrowth = props.growth?.length ?? 0;
    let growthItem = props?.growth;
    let plannedItem = props?.planned;
    let unPlannedItem = props?.unplanned;
    let disableQuantityButton = props?.disableQuantityButton;
    let resetButtons = props?.resetButtons;
    let itemDetail = props?.itemDetail;
    let setQuantityLevelComments = props?.setQuantityLevelComments;
    let quantityLevelComments = props?.quantityLevelComments;
    let disableButton = props?.disableButton;

    const ExpandedItems = [
        {
            headerText: <div className="accordionHeader">
                <div className="accordionHeaderLeft">
                    <p className='accord-heading'>REQUEST REASON DETAILS ({lengthPlanned + lengthUnPlanned + lengthGrowth})</p>
                </div>
            </div>,
            content: <>
                {
                    props.viewType == 'OrderDetail-screen' && <div>
                        {props.planned?.length ?
                            <div className='tableBlock px-3'>
                                <p className='heading'>Planned</p>
                                <Table column={props.plannedColumn} data={props.planned}  data-attribute="RequestReasonDetail_Default_Table" />
                            </div> : null
                        }
                        {
                            props.growth?.length ?
                                <div className='tableBlock px-3'>
                                    <p className='heading'>Growth</p>
                                    {
                                        props?.tableVal == "businessTable" && <Table column={props.businessTable} data={props.growth}  data-attribute="RequestReasonDetail_Default_Table_2" />
                                    }
                                    {
                                        props?.tableVal == "employeeTable" && <Table column={props.employeeTable} data={props.growth}  data-attribute="RequestReasonDetail_Default_Table_3" />
                                    }
                                    {
                                        props?.tableVal == "comboTable" && <Table column={props.comboTable} data={props.growth}  data-attribute="RequestReasonDetail_Default_Table_4" />
                                    }
                                </div> : null
                        }
                        {
                            props.unplanned?.length ?
                                <div className='tableBlock px-3'>
                                    <p className='heading'>Unplanned</p>
                                    <Table column={props.unplannedColumn} data={props.unplanned}  data-attribute="RequestReasonDetail_Default_Table_5" />
                                </div> : null
                        }
                        {

                        }
                    </div>}
                {
                    props.viewType == 'Approval-screen' && <>
                        <RequestReasonDetailApprovalOrder quantityLevelComments={quantityLevelComments} setQuantityLevelComments={setQuantityLevelComments} itemDetail={itemDetail} disableQuantityButton={disableQuantityButton} growthItem={growthItem} plannedItem={plannedItem} unPlannedItem={unPlannedItem} setDisableButton={props?.setDisableButton} />
                    </>
                }
            </>
        }
    ]
    const approvesubtext = <><p>Are you sure you want to Approve the item</p><p>{(props?.itemDetail?.subOrderType == CONSTANTS.PRODUCTION_VEHICLE || props?.itemDetail?.subOrderType == CONSTANTS.MANAGEMENT_VEHICLE) ? <b>{(props?.itemDetail?.subOrderType)}</b> : <b>{(props?.itemDetail?.orderType)}</b>}</p></>
    const moreInfosubtext = <><p>Are you sure you want to request more information</p><p>{(props?.itemDetail?.subOrderType == CONSTANTS.PRODUCTION_VEHICLE || props?.itemDetail?.subOrderType == CONSTANTS.MANAGEMENT_VEHICLE) ? <b>{(props?.itemDetail?.subOrderType)}</b> : <b>{(props?.itemDetail?.orderType)}</b>}</p></>
    const rejectsubtext = <><p>Are you sure you want to Reject the item</p><p>{(props?.itemDetail?.subOrderType == CONSTANTS.PRODUCTION_VEHICLE || props?.itemDetail?.subOrderType == CONSTANTS.MANAGEMENT_VEHICLE) ? <b>{(props?.itemDetail?.subOrderType)} </b> : <b>{(props?.itemDetail?.orderType)}</b>}</p></>
    function _onChange(_ev: React.FormEvent<HTMLInputElement>, option: any): void {
        if (option?.key === 'Approve') {
            props?.setPopupcontent({ ...props?.Popupcontent, titleImg: Approved, title: 'APPROVE', isDialogVisible: true, isTitleWarning: false, subtextcontent: approvesubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Approve", value: option?.value, comment: "" })
        }
        if (option?.key === 'Request More Info') {
            props?.setPopupcontent({ ...props?.Popupcontent, titleImg: Moreinfo, title: 'REQUEST MORE INFO', isDialogVisible: true, isTitleWarning: false, subtextcontent: moreInfosubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Moreinfo", value: option?.value, comment: "", isCommentBoxRequire: true })
        }
        if (option?.key === 'Reject') {
            props?.setPopupcontent({ ...props?.Popupcontent, titleImg: Rejected, title: 'REJECT', isDialogVisible: true, isTitleWarning: false, subtextcontent: rejectsubtext, primaryBtnText: 'Yes', outlineBtnText: 'No', isSingleConfirmationBtn: false, isCommentboxVisible: true, isCompletedReportVisible: false, outlineBtnnavigateTo: "", primaryBtnnavigateTo: "", actionby: "Rejected", value: option?.value, comment: "", isCommentBoxRequire: true })
        }
    }

    return <div className={`RequestReasonDetail RequestReasonDetailApprovalOrder ${props?.isBulkOrder ? 'bulk-order-request p-3' : ''}`}>
        {!props?.isBulkOrder && <Accordion Items={ExpandedItems} uuid='Accordion1' className='requestreason-approvalorder-accordion pb-2'  data-attribute="RequestReasonDetail_Default_Accordion" />}
        {
            props.viewType == 'Approval-screen' && <>
                {(props.orderByIdValue?.requests?.length > 1 || props.orderByIdValue?.requests?.length == 1 && props.orderByIdValue?.requests[0]?.reasons?.length > 1) &&
                    <div className={`approval-all-block ${disableButton ? 'disabled-button' : 'not-disabled'} ${props?.isBulkOrder ? 'bulk-order-radios': ''}`}><RadioContainer selectedKey={props?.selectedOption ?? ''} options={props?.approverActionList} onChange={_onChange} id={props?.index}  data-attribute="RequestReasonDetail_Default_Radio" /><span className='mt-2'><a href='/' onClick={(e: any) => resetButtons(e, props?.index)}>Reset</a></span></div>
                }
                <PopupDialogbox hideDialog={!props?.Popupcontent.isDialogVisible} onDismiss={props?.closeDialogHandler} Popupcontent={props?.Popupcontent} popupOutlinebtnOnclick={props?.popupOutlinebtnOnclick} popupPrimarybtnOnclick={props?.popupPrimarybtnOnclick}  data-attribute="RequestReasonDetail_Default_PopupDilalogBox" />
            </>
        }
    </div>
}

export default RequestReasonDetail
